import React from 'react';
import CTABanner from '../components/landingPage/CTABanner';
import SocialMediaCTA from '../components/SocialMediaCTA';
import NewsSection from '../components/landingPage/NewsSection';

const CompanyBgPage = () => {
  return (
    <div className="min-h-screen pt-20 bg-gray-100 font-poppins">
      {/* Hero Section */}
      <section className="relative h-64 sm:h-80 md:h-96 bg-cover bg-center" style={{ backgroundImage: "url('/hero_img/image-04.jpg')" }}>
        <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
          <h1 className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-center drop-shadow-lg font-poppins mx-auto w-11/12 md:w-3/4 lg:w-2/3">
            Our Company Background
          </h1>
        </div>
      </section>

      {/* Content Section 1 */}
      <section className="container mx-auto px-4 py-12 sm:py-16">
        <h2 className="text-3xl sm:text-4xl font-bold text-main-blue mb-6 sm:mb-8 text-center">
          Background of Company
        </h2>
        <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6">
          MK Metal & Engineering Works Sdn. Bhd.(1439610-V), incorporated on 22nd November 2021, is a private limited company in Malaysia specializing in steel fabrication. Over the years, we have grown to be one of the most versatile steel fabricators in Malaysia. Throughout our years of operation, we have achieved significant growth and progress through our proven expertise and diversified field of operations.
        </p>
        <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6">
          Led by a team consisting of the visionary founder and young, talented employees, MK Metal & Engineering Works Sdn. Bhd.(1439610-V) is able to demonstrate responsiveness and flexibility when it comes to providing solutions for customers. Our management and dedicated staff have a wealth of knowledge and experience and are committed to quality service and product. All our products are manufactured to exacting quality standards to meet or exceed our customers’ expectations.
        </p>
        <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed">
          MK Metal & Engineering Works Sdn. Bhd.(1439610-V) always strives for quality and reliability in serving our customers as we strongly believe in gaining customers’ trust to achieve greater success. Therefore, we always work together to continuously improve our services and also anticipate the future needs of our customers. The satisfaction of our customers is our main goal.
        </p>
      </section>

      {/* Vision Section */}
      <section className="bg-main-blue py-12 sm:py-16 px-4 text-white">
        <div className="container mx-auto text-center">
          <h3 className="text-3xl sm:text-4xl font-bold mb-3 sm:mb-4">
            Our Vision
          </h3>
          <p className="text-sm sm:text-base md:text-lg leading-relaxed max-w-3xl mx-auto">
            Driven by the vision of being one of the best Steel fabrication companies, MK METAL & ENGINEERING WORKS will continue to strive for excellence in order to Fulfil the needs and satisfaction of our customers.
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="bg-gray-800 py-12 sm:py-16 px-4 text-white">
        <div className="container mx-auto text-center">
          <h3 className="text-3xl sm:text-4xl font-bold mb-3 sm:mb-4">
            Our Mission
          </h3>
          <p className="text-sm sm:text-base md:text-lg leading-relaxed max-w-3xl mx-auto">
            To achieve our mission, MK METAL & ENGINEERING WORKS will always provide the greatest service as well as the highest quality and workmanship in its goods via the devotion and commitment of its personnel.
          </p>
        </div>
      </section>

      {/* CTABanner, SocialMediaCTA, NewsSection */}
      <CTABanner className="my-8 sm:my-12" />
      <SocialMediaCTA className="my-8 sm:my-12" />
      <NewsSection className="my-8 sm:my-12" />
    </div>
  );
};

export default CompanyBgPage;
